import React from 'react';

class DefaultIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_241_1355)">
          <path
            d="M72.924 25.9738C72.368 23.6618 71.562 21.5078 70.416 19.4198C69.282 17.3558 67.864 15.4678 66.2 13.8018C64.536 12.1378 62.646 10.7178 60.584 9.58582C58.492 8.43782 56.338 7.63182 54.022 7.07582C49.432 5.97182 44.634 5.99982 40.002 5.99982C35.37 5.99982 30.568 5.97182 25.976 7.07582C23.664 7.63182 21.51 8.43782 19.422 9.58382C17.358 10.7178 15.47 12.1358 13.806 13.7998C12.142 15.4638 10.722 17.3538 9.59002 19.4178C8.44202 21.5078 7.63602 23.6638 7.07802 25.9798C5.97402 30.5698 6.00202 35.3678 6.00202 39.9998C6.00202 44.6318 5.97402 49.4338 7.08002 54.0258C7.63602 56.3378 8.44202 58.4918 9.58802 60.5798C10.722 62.6438 12.14 64.5318 13.804 66.1978C15.468 67.8618 17.358 69.2818 19.422 70.4138C21.512 71.5618 23.668 72.3678 25.984 72.9238C30.574 74.0278 35.372 73.9998 40.004 73.9998C44.636 73.9998 49.438 74.0278 54.032 72.9238C56.344 72.3678 58.496 71.5618 60.586 70.4158C62.65 69.2818 64.538 67.8638 66.204 66.1998C67.868 64.5358 69.288 62.6458 70.42 60.5838C71.568 58.4938 72.374 56.3378 72.932 54.0218C74.036 49.4318 74.006 44.6338 74.006 40.0018C74.006 35.3698 74.036 30.5678 72.93 25.9758"
            fill="#F7F4F1"
          />
          <path
            d="M39.3162 74.7999C34.8522 74.7999 30.2482 74.7739 25.7942 73.7019C23.3402 73.1119 21.1282 72.2659 19.0342 71.1139C16.9062 69.9459 14.9562 68.4799 13.2362 66.7619C11.5182 65.0419 10.0542 63.0919 8.88424 60.9639C7.73424 58.8699 6.88824 56.6619 6.29824 54.2119C5.19824 49.6399 5.19824 44.9119 5.19824 40.3399V39.6559C5.19824 35.0859 5.19824 30.3599 6.29624 25.7919C6.88624 23.3399 7.73224 21.1279 8.88424 19.0319C10.0542 16.9039 11.5182 14.9539 13.2362 13.2339C14.9542 11.5159 16.9042 10.0519 19.0342 8.88192C21.1282 7.73192 23.3362 6.88592 25.7862 6.29792C30.3562 5.19792 35.0802 5.19992 39.6542 5.19792H40.3442C44.9142 5.19392 49.6382 5.19792 54.2062 6.29592C56.6582 6.88592 58.8682 7.73192 60.9662 8.88392C63.0962 10.0539 65.0462 11.5179 66.7642 13.2359C68.4822 14.9539 69.9462 16.9059 71.1162 19.0339C72.2662 21.1259 73.1102 23.3339 73.7022 25.7859C74.8022 30.3539 74.8022 35.0799 74.8002 39.6499V40.3499C74.8002 44.9179 74.8002 49.6399 73.7042 54.2059C73.1142 56.6579 72.2682 58.8699 71.1162 60.9659C69.9482 63.0939 68.4822 65.0439 66.7642 66.7639C65.0462 68.4819 63.0942 69.9479 60.9662 71.1159C58.8722 72.2659 56.6642 73.1119 54.2162 73.7019C49.6442 74.8019 44.9162 74.8059 40.3422 74.8019H39.3182L39.3162 74.7999ZM40.0002 73.1999H40.3422C44.8242 73.1999 49.4542 73.1999 53.8402 72.1459C56.1502 71.5899 58.2282 70.7939 60.1962 69.7139C62.1922 68.6179 64.0222 67.2459 65.6342 65.6339C67.2462 64.0219 68.6202 62.1919 69.7162 60.1979C70.7982 58.2279 71.5942 56.1459 72.1502 53.8339C73.2042 49.4519 73.2022 44.8259 73.2022 40.3519V39.6519C73.2022 35.1759 73.2022 30.5459 72.1482 26.1619C71.5922 23.8519 70.7962 21.7719 69.7162 19.8059C68.6202 17.8099 67.2462 15.9819 65.6342 14.3699C64.0242 12.7579 62.1942 11.3859 60.1982 10.2879C58.2282 9.20592 56.1462 8.40992 53.8342 7.85392C49.4502 6.79992 44.8242 6.79992 40.3482 6.79992H39.6562C35.1802 6.80392 30.5482 6.79992 26.1622 7.85392C23.8522 8.40992 21.7722 9.20592 19.8062 10.2859C17.8102 11.3819 15.9802 12.7559 14.3702 14.3659C12.7582 15.9779 11.3862 17.8079 10.2882 19.8019C9.20624 21.7719 8.41024 23.8539 7.85424 26.1659C6.80024 30.5499 6.80024 35.1799 6.80224 39.6559V40.3399C6.80224 44.8179 6.80224 49.4499 7.85624 53.8359C8.41224 56.1459 9.20824 58.2239 10.2882 60.1919C11.3842 62.1879 12.7562 64.0159 14.3682 65.6279C15.9802 67.2399 17.8102 68.6119 19.8042 69.7099C21.7722 70.7919 23.8542 71.5879 26.1682 72.1439C30.5522 73.1979 35.1842 73.1979 39.6602 73.1959H40.0022L40.0002 73.1999Z"
            fill="#84827E"
          />
          <path
            d="M40.0001 55.5318C32.5261 55.5318 25.5081 52.2218 20.7461 46.4518L26.3821 41.7998C29.7501 45.8818 34.7141 48.2238 40.0001 48.2238C45.2861 48.2238 50.2501 45.8818 53.6201 41.7998L59.2561 46.4518C54.4941 52.2218 47.4761 55.5318 40.0021 55.5318"
            fill="#83827F"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_241_1355"
            x="3.79824"
            y="3.79751"
            width="75.6025"
            height="75.6047"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_1355"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_1355"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  }
}

export default DefaultIcon;
